import * as React from "react";

function SvgMutiny(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M191.49 191.49h2746.595v995.744H191.49zm49.787 49.787v896.17h2647.02v-896.17z"
      />
      <path d="M806.911 661.345L951.878 499.93h23.133V873.14h-74.54l.514-205.112-94.074 98.7-94.074-98.7V873.14h-74.54V499.93h23.648zm514.58 83.793c0 174.782-265.772 174.782-265.772 0V505.583h73.511v239.04c0 77.11 119.264 77.11 119.264 0v-239.04h72.997v239.555zm215.393 128.002h-73.511V579.095h-91.504v-72.998h256.519v72.998h-91.504V873.14zm220.534 0h-73.511V505.583h73.511V873.14zm156.276-199.971V873.14h-73.511V497.872h19.534l185.578 215.908V506.097h74.025v374.754h-19.534L1913.694 673.17zm378.352 199.971V707.611l-128.002-202.028h89.447l75.054 126.46 75.054-126.46h89.961l-128.516 202.028v165.53h-72.998z" />
    </svg>
  );
}

export default React.forwardRef(SvgMutiny);
